var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord"
  }, /*#__PURE__*/React.createElement("path", {
    id: "discord_2",
    d: "M23.6875 7.82501C22.0625 7.08751 20.325 6.55 18.525 6.25C18.3 6.6375 18.05 7.1625 17.875 7.575C15.95 7.3 14.05 7.3 12.15 7.575C11.975 7.1625 11.7125 6.6375 11.5 6.25C9.68752 6.55 7.95001 7.08751 6.33751 7.82501C3.06251 12.6 2.17501 17.2625 2.62501 21.8625C4.80001 23.425 6.90002 24.375 8.96252 25C9.46252 24.325 9.92501 23.6 10.3125 22.8375C9.56251 22.5625 8.85002 22.225 8.17502 21.825C8.35002 21.7 8.52502 21.5625 8.68752 21.425C12.8 23.2875 17.275 23.2875 21.3375 21.425C21.5125 21.5625 21.675 21.7 21.85 21.825C21.175 22.225 20.4625 22.5625 19.7125 22.8375C20.1 23.6 20.5625 24.325 21.0625 25C23.125 24.375 25.2375 23.425 27.4 21.8625C27.95 16.5375 26.5375 11.9125 23.7125 7.82501H23.6875ZM10.85 18.9625C9.6125 18.9625 8.60001 17.8375 8.60001 16.4625C8.60001 15.0875 9.5875 13.9625 10.85 13.9625C12.1125 13.9625 13.125 15.0875 13.1 16.4625C13.1 17.8375 12.1 18.9625 10.85 18.9625ZM19.15 18.9625C17.9125 18.9625 16.9 17.8375 16.9 16.4625C16.9 15.0875 17.8875 13.9625 19.15 13.9625C20.4125 13.9625 21.425 15.0875 21.4 16.4625C21.4 17.8375 20.4125 18.9625 19.15 18.9625Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.8bea30be404be3840ba9627c7037015b.svg";
export { ForwardRef as ReactComponent };